import { render, staticRenderFns } from "./OrganizationPage.vue?vue&type=template&id=063af7b5&scoped=true"
import script from "./OrganizationPage.vue?vue&type=script&lang=js"
export * from "./OrganizationPage.vue?vue&type=script&lang=js"
import style1 from "./OrganizationPage.vue?vue&type=style&index=1&id=063af7b5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "063af7b5",
  null
  
)

export default component.exports